/**
 * Public layout component with header and footer
 * @module layouts/PublicLayout
 *
 * ĐÂY LÀ BẢN DUY NHẤT. Trước 03/09/2026 App.tsx dựng lại một PublicLayout y hệt
 * còn file này nằm không, nên sửa vào đây chẳng đổi gì trên màn hình mà không
 * có dấu hiệu nào báo. Cần đổi header/chân trang của các trang công khai thì
 * sửa ở đây, đừng thêm bản thứ hai.
 *
 * Trang nào KHÔNG muốn có header/chân trang (tra cứu nhúng Mezon, danh sách thi,
 * chatbot nhúng…) thì khai route ĐỨNG NGOÀI layout này trong App.tsx.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { isBuildLocal } from '../core/config/environment';

export const PublicLayout: React.FC = () => {
  const isLocal = isBuildLocal();

  return (
    <>
      {!isLocal && <Header />}
      <div className="main-content">
        <Outlet />
      </div>
      {!isLocal && <Footer />}
    </>
  );
};

export default PublicLayout;
